module.exports = __webpack_public_path__ + "img/Barna.7ada3863.png";